import { Injectable } from '@angular/core';
import { SplugParametersConfigurationRemoteControllerService } from 'core/api';
import { ISplugParametersConfigurationDto } from 'core/dto';
import { RemoteCollectionService, RemoteCollectionStore } from 'core/remotes';
import { BehaviorSubject } from 'rxjs';
import { ISplugParametersConfiguration } from '../../../sign-process-wizard/remotes/remote-splug-parameters-configuration.service';


@Injectable()
export class RemoteUserSplugParametersConfigurationService extends RemoteCollectionService<ISplugParametersConfigurationDto, ISplugParametersConfiguration> {

  readonly splugParametersConfigurationsSubject = this.localCollectionStore.stateSubject;
  readonly userIdSubject = new BehaviorSubject<string>(null);
  get userId() {
    return this.userIdSubject.value
  }

  constructor(
    private readonly _splugParametersConfigurationRemoteControllerService: SplugParametersConfigurationRemoteControllerService
  ) {

    super();
    super.setConfig({
      remoteStore: new RemoteCollectionStore<ISplugParametersConfigurationDto, string>({
        keyField: 'id',
        byKey: (id: string) => _splugParametersConfigurationRemoteControllerService.getOne(id),
        load: () => _splugParametersConfigurationRemoteControllerService.getByUser(this.userId || ''),
        insertBatch: (insertDtoArray) => _splugParametersConfigurationRemoteControllerService.insertBatch(insertDtoArray)
      })
    })
  }
}
